import config from "utils/apiconfig";
import request from "utils/request";

const { api } = config;
const { monthreport, monthreportId } = api;

/**
 * 查询河流列表
 */
export async function monthreportList(params) {
  return request({ url: monthreport, method: "get", data: params });
}

/**
 * 查询河流详情
 */
export async function monthreportDetail(id) {
  return request({
    url: monthreportId,
    method: "get",
    data: {
      damId: id
    }
  });
}
